import React, { useState, useEffect } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Input,
  Button,
  FormLabel,
  Select,
} from '@chakra-ui/react';

const AddCustomerModal = ({ 
  isOpen, 
  closeAddClientModal, 
  handleSubmitNewCustomer, 
  customerTypes,
  localities,
}) => {
  // Initialize state for customer fields
  const [name, setName] = useState('');
  const [document, setDocument] = useState('');
  const [address, setAddress] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [customerTypeId, setCustomerTypeId] = useState('');
  const [localityId, setLocalityId] = useState('');

  // Reset fields when modal opens
  useEffect(() => {
    if (isOpen) {
      setName('');
      setDocument('');
      setAddress('');
      setPhone('');
      setEmail('');
      setCustomerTypeId('');
      setLocalityId('');
    }
  }, [isOpen]);

  const handleAddCustomer = () => {
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().split('T')[0]; // Get yyyy-mm-dd format

    const newCustomer = {
      name,
      document,
      address,
      phone,
      email,
      customerTypeId,
      localityId,
      createdAt: formattedDate, // Add createdAt
      updatedAt: formattedDate, // Add updatedAt
    };

    handleSubmitNewCustomer(newCustomer);
  };

  return (
    <Modal isOpen={isOpen} onClose={closeAddClientModal} isCentered closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent maxW="md" p={4}>
        <ModalHeader textAlign="center">Agregar Nuevo Cliente</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormLabel>Nombre</FormLabel>
          <Input 
            placeholder="Ingrese el nombre" 
            value={name} 
            onChange={(e) => setName(e.target.value)} 
            mb={4} 
          />
          <FormLabel>Documento</FormLabel>
          <Input 
            placeholder="Ingrese el documento" 
            value={document} 
            onChange={(e) => setDocument(e.target.value)} 
            mb={4} 
          />
          <FormLabel>Dirección</FormLabel>
          <Input 
            placeholder="Ingrese la dirección" 
            value={address} 
            onChange={(e) => setAddress(e.target.value)} 
            mb={4} 
          />
          <FormLabel>Teléfono</FormLabel>
          <Input 
            placeholder="Ingrese el teléfono" 
            value={phone} 
            onChange={(e) => setPhone(e.target.value)} 
            mb={4} 
          />
          <FormLabel>Correo Electrónico</FormLabel>
          <Input 
            placeholder="Ingrese el correo electrónico" 
            value={email} 
            onChange={(e) => setEmail(e.target.value)} 
            mb={4} 
          />
          <FormLabel>Tipo de Cliente</FormLabel>
          <Select 
            placeholder="Seleccione el tipo de cliente" 
            value={customerTypeId} 
            onChange={(e) => setCustomerTypeId(e.target.value)} 
            mb={4}
          >
            {customerTypes?.map(type => (
              <option key={type.id} value={type.id}>
                {type.type}
              </option>
            ))}
          </Select>
          <FormLabel>Localidad</FormLabel>
          <Select 
            placeholder="Seleccione la localidad" 
            value={localityId} 
            onChange={(e) => setLocalityId(e.target.value)} 
            mb={4}
          >
            {localities?.map(locality => (
              <option key={locality.id} value={locality.id}>
                {locality.name}
              </option>
            ))}
          </Select>
        </ModalBody>
        <ModalFooter justifyContent="center">
          <Button variant="adminPrimary" onClick={handleAddCustomer}>
            Agregar
          </Button>
          <Button colorScheme="gray" onClick={closeAddClientModal}>
            Cancelar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default AddCustomerModal;